// @ is an alias to /src
import mastertime from '@/api/mastertime'

export const namespaced = true

export const state = {
  currentUser: JSON.parse(localStorage.getItem('current_user')),
}

export const mutations = {
  setCurrentUser(state, currentUser) {
    state.currentUser = currentUser
  },
}

export const actions = {
  async software3rdParty(_, credential) {
    const { data } = await mastertime.software3rdParty(credential)

    localStorage.setItem('refresh_token', data.refresh_token)
    localStorage.setItem('access_token', data.access_token)
  },
  async login({ commit }, credential) {
    const { data } = await mastertime.login(credential)

    localStorage.setItem('refresh_token', data.refresh_token)
    localStorage.setItem('access_token', data.access_token)
    localStorage.setItem('current_user', JSON.stringify(data.taff_admin))

    commit('setCurrentUser', data.taff_admin)
  },
  logout({ commit }) {
    localStorage.clear()

    commit('setCurrentUser', null)
    return Promise.resolve()
  },
  async changePassword(_, credential) {
    await mastertime.changePassword(credential)
  },
}
